import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDLabelText,
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { RoadmapDeliverableWrapperLayout } from '../Wrapper/RoadmapDeliverableWrapperLayout';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  if (!resource) {
    return null;
  }

  const labelValue = resource.meta().field('discussionTopics').attr('prompt') || 'I\'d like to discuss (select all that apply):';

  return (
    <RoadmapDeliverableWrapperLayout>
      <FDStack direction="column" spacing={1} width={'100%'} maxWidth={600}>
        <FDStack direction="column" alignItems={'center'}>
          <FDLabelText value={labelValue} size={'md'} />
        </FDStack>
        <MetaControlField attr={'discussionTopics'} />
        <FDPaper appearance={'flat'}>
          <MetaControlField attr={'userEnteredDiscussionTopic'} />
        </FDPaper>
      </FDStack>
    </RoadmapDeliverableWrapperLayout>
  );
};

export default Layout;
